import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/common/components/base.component';
import { ButtonTriggerEvent } from 'src/app/common/components/button/button.component';

@Component({
  templateUrl: './input.modal.component.html',
  styleUrls: ['./input.modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputModalComponent extends BaseComponent {

  data: InputModalData;
  actions: InputModalActions;
  value: string;
  form: FormGroup;
  originalValue: string = '';
  isChanged = false;

  constructor(
    private dialogRef: MatDialogRef<InputModalComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    data: any) {
    super();

    this.data = Object.assign({}, data.data);
    this.actions = Object.assign({}, data.actions);
    if (this.data.inputModalValue) {
      this.value = this.data.inputModalValue;
    }
  }

  public ngOnInit() {
    this.originalValue = (this.value || '').trim();
    this.form = this.formBuilder.group({
      'text': [
        this.value || '',
        [
          (control: AbstractControl): ValidationErrors | null => this.httpUrlValidator(control),
        ],
      ],
    });

    this.form
      .get('text')
      ?.valueChanges.subscribe((v) => (this.isChanged = (v || '').trim() !== this.originalValue));
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public confirm(event: ButtonTriggerEvent) {
    // ensure we read the latest input value and trim it
    const latest = (this.form.get('text')?.value ?? this.value ?? '').toString().trim();
    this.value = latest;
    // Only validate URL format if a value is provided
    if (latest) {
      try {
        const u = new URL(latest);
        if (u.protocol !== 'http:' && u.protocol !== 'https:') return; // protocol guard
      } catch {
        return; // invalid URL guard
      }
    }
    if (this.data.isAsync) {
      let oldFunc = event.complete;
      event.complete = () => {
        oldFunc();

        this.dialogRef.close();
      };

      this.actions.confirm(event, this.value);
    } else {
      this.actions.confirm(event, this.value);
      this.dialogRef.close();
    }
  }

  private httpUrlValidator(control: AbstractControl): ValidationErrors | null {
    const v = (control.value || '').toString().trim();
    // Allow empty values, only validate URL format when a value is provided
    if (!v) return null;
    try {
      const u = new URL(v);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return { protocol: true };
      return null;
    } catch (e) {
      return { url: true };
    }
  }
}

export class InputModalActions {
  confirm: (event: ButtonTriggerEvent, data: string) => void;
  cancel?: () => void;
}

export class InputModalData {
  inputModalTitle?: string;
  inputModalHelpText?: string;
  inputModalValue?: string;
  inputModalConfirmButtonText?: string;
  inputModalCancelButtonText?: string;
  isAsync?: boolean;

  constructor(title: string, helpText: string, value: string, confirmBtnText: string, cancelBtnText: string, isAsync: boolean) {
    this.inputModalTitle = title;
    this.inputModalHelpText = helpText;
    this.inputModalValue = value;
    this.inputModalConfirmButtonText = confirmBtnText;
    this.inputModalCancelButtonText = cancelBtnText;
    this.isAsync = isAsync;
  }
}

